module.exports = __webpack_public_path__ + "img/logo_western_union1.02fb5b76.png";